// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import checkoutPageContainerStyles from "@steiner/App/SharedStyles/CheckoutPages/CheckoutPageContainerStyles";
import { pageContainerStyles } from "@steiner/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import { DivWrapper } from "@steiner/XDL/constants";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

pageContainerStyles.container = {
    ...checkoutPageContainerStyles.container,
};

pageContainerStyles.leftContainer = {
    ...checkoutPageContainerStyles.leftSection,
};

pageContainerStyles.rightContainer = {
    ...checkoutPageContainerStyles.rightSection,
};

pageContainerStyles.innerContainer = {
    css: css`
        width: 100%;
        margin-top: 24px;
        display: grid;
        grid-template-columns: 1fr 317px;
        grid-template-rows: auto;
        gap: 24px 22px;
        ${xScreen("lte", "md")} {
            display: flex;
            flex-direction: column;
        }
    `,
};

pageContainerStyles.cartMessagesContainer = {
    css: css`
        grid-area: 1 / 1 / 2 / 3;
        ${xScreen("lte", "sm")} {
            grid-area: 1 / 1 / 2 / 3;
        }
    `,
};

const sameHeightStyle = css`
    & > ${DivWrapper} {
        &,
        & > div {
            height: 100%;
        }
    }
`;

pageContainerStyles.shippingBillingInformationContainer = {
    css: css`
        grid-area: 2 / 1 / 3 / 2;
        ${xScreen("lte", "sm")} {
            grid-area: 2 / 1 / 3 / 3;
        }

        ${sameHeightStyle}
    `,
};

pageContainerStyles.shippingMethodContainer = {
    css: css`
        grid-area: 2 / 2 / 3 / 3;
        ${xScreen("lte", "sm")} {
            grid-area: 3 / 1 / 4 / 3;
        }

        ${sameHeightStyle}
    `,
};

pageContainerStyles.paymentMethodContainer = {
    css: css`
        grid-area: 3 / 1 / 4 / 2;
        ${xScreen("lte", "sm")} {
            grid-area: 4 / 1 / 5 / 3;
        }

        ${sameHeightStyle}
    `,
};

pageContainerStyles.promotionContainer = {
    css: css`
        grid-area: 3 / 2 / 4 / 3;
        ${xScreen("lte", "sm")} {
            grid-area: 5 / 1 / 6 / 3;
        }
    `,
};

pageContainerStyles.productListContainer = {
    css: css`
        grid-area: 4 / 1 / 5 / 3;
        ${xScreen("lte", "sm")} {
            grid-area: 6 / 1 / 7 / 3;
        }
    `,
};

pageContainerStyles.freightNotify = {
    css: css`
        margin-bottom: 0;
    `,
};
